import w from "@arcgis/core/layers/FeatureLayer";
import g from "@arcgis/core/Graphic";
import _ from "@arcgis/core/request";
import { createLogger as ee } from "@origo/logger";
import ne from "@arcgis/core/geometry/Point";
import re from "@arcgis/core/geometry/Polygon";
import { z as u } from "zod";
import { jsx as te } from "react/jsx-runtime";
import { createContext as ae, useContext as Q } from "react";
import { useQuery as k, useQueryClient as y, useMutation as b } from "@tanstack/react-query";
class F extends Error {
  constructor(n, r) {
    super(n, r), this.name = "PlanregisterError";
  }
}
class I extends F {
  constructor(n, r) {
    super(`${n} not found: ${r}`), this.name = "NotFoundError";
  }
}
class P extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "ValidationError";
  }
}
class j extends F {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "NetworkError";
  }
}
class oe extends F {
  constructor(n = "Unauthorized") {
    super(n), this.name = "AuthError";
  }
}
class G extends F {
  constructor() {
    super("Operation was aborted"), this.name = "AbortedError";
  }
}
const V = "1";
function L(e) {
  return e.trim().padStart(4, "0");
}
function z(e, n) {
  return `${L(e)}_${n.trim()}`;
}
const H = [
  "plantype",
  "planstatus",
  "lovreferanse",
  "forslagsstillerType"
];
function se(e, n, r) {
  return r == null || r === "" ? "" : e?.[n]?.find((l) => l.code === r)?.label ?? r;
}
function le(e, n) {
  return e?.[n] ?? [];
}
const W = [
  "planbehandlingtype"
], Mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: G,
  AuthError: oe,
  CODELIST_FIELDS: H,
  DEFAULT_PLANSTATUS: V,
  NetworkError: j,
  NotFoundError: I,
  PLANBEHANDLING_CODELIST_FIELDS: W,
  PlanregisterError: F,
  ValidationError: P,
  deriveNasjonalArealplanId: z,
  domainLabel: se,
  domainOptions: le,
  normalizeAdmomrkode: L
}, Symbol.toStringTag, { value: "Module" }));
function D(e) {
  if (e != null)
    return new Date(e);
}
function $(e) {
  return !!e;
}
function ie(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer ?? "",
    saksaar: e.saksaar,
    sakssekvensnr: e.sakssekvensnr,
    forslagsstillerType: e.forslagsstillerType,
    ubehandletKlage: $(e.ubehandletKlage),
    ubehandletInnsigelse: $(e.ubehandletInnsigelse),
    vedtaksdato: D(e.vedtaksdato),
    vedtakEndeligPlanDato: D(e.vedtakEndeligPlanDato),
    ikrafttredelsesdato: D(e.ikrafttredelsesdato),
    kunngjoringsdato: D(e.kunngjoringsdato),
    opprinneligAdmomrKode: e.opprinneligAdmomrKode,
    opprinneligPlanId: e.opprinneligPlanId,
    planbestemmelser: $(e.planbestemmelser)
  };
}
function R(e) {
  return {
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer,
    saksaar: e.saksaar ?? null,
    sakssekvensnr: e.sakssekvensnr ?? null,
    forslagsstillerType: e.forslagsstillerType ?? null,
    ubehandletKlage: e.ubehandletKlage ? 1 : 0,
    ubehandletInnsigelse: e.ubehandletInnsigelse ? 1 : 0,
    vedtaksdato: e.vedtaksdato?.getTime() ?? null,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    ikrafttredelsesdato: e.ikrafttredelsesdato?.getTime() ?? null,
    kunngjoringsdato: e.kunngjoringsdato?.getTime() ?? null,
    opprinneligAdmomrKode: e.opprinneligAdmomrKode ?? null,
    opprinneligPlanId: e.opprinneligPlanId ?? null,
    planbestemmelser: e.planbestemmelser ? 1 : 0
  };
}
function Qn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...R(e)
  };
}
function de(e) {
  const n = e;
  return n && n.type === "coded-value" && Array.isArray(n.codedValues) ? n.codedValues : null;
}
function Y(e, n) {
  const r = new Map(e.map((l) => [l.name, l])), a = {};
  for (const l of n) {
    const d = de(r.get(l)?.domain);
    a[l] = d ? d.map((t) => ({ code: String(t.code), label: t.name })) : [];
  }
  return a;
}
function ue(e) {
  return Y(e, H);
}
function ce(e) {
  return e.replace(/'/g, "''");
}
function h(e) {
  return `'${ce(e)}'`;
}
function Gn(e, n) {
  return n.length === 0 ? "1=0" : `${e} IN (${n.map(h).join(",")})`;
}
const me = ee("planregister:queryTablePaged"), pe = 2e3, fe = 1e3;
async function C(e, n, r) {
  const a = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: n.returnGeometry === !0,
    f: "json"
  };
  n.orderByFields && (a.orderByFields = n.orderByFields);
  const l = [];
  let d = 0;
  try {
    for (let t = 0; t < fe; t++) {
      const s = (await _(`${e}/query`, {
        query: { ...a, resultOffset: d, resultRecordCount: pe },
        method: "post",
        responseType: "json",
        signal: r?.signal
      })).data, i = s?.features ?? [];
      for (const p of i)
        l.push(
          p.geometry ? { attributes: p.attributes, geometry: { ...p.geometry, spatialReference: s.spatialReference } } : { attributes: p.attributes }
        );
      if (s?.exceededTransferLimit !== !0 || i.length === 0)
        break;
      d += i.length;
    }
  } catch (t) {
    throw r?.signal?.aborted || ge(t) ? new G() : (me.error(`Feil ved query mot ${e}:`, t), new j(`Query mot ${e} feilet: ${t?.message ?? t}`, t));
  }
  return l;
}
async function E(e, n, r) {
  return (await C(e, n, r)).map((l) => l.attributes);
}
function ge(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
function ye(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await E(e, { where: t }, o)).map(ie);
  return {
    findAll: (t) => d("1=1", t),
    findByNapId: async (t, o) => (await d(`nasjonalArealplanId = ${h(t)}`, o))[0] ?? null,
    search: (t, o) => {
      const s = h(`%${t}%`);
      return d(
        `LOWER(plannavn) LIKE LOWER(${s}) OR nasjonalArealplanId LIKE ${s} OR planId LIKE ${s}`,
        o
      );
    },
    add: async (t) => l(async () => {
      const o = new g({ attributes: R(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("Arealplan", p);
      return f[0];
    }, "ArealplanRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...R(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Arealplan", t.objectId);
      return i[0];
    }, "ArealplanRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "ArealplanRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), ue(t.fields);
    }, "ArealplanRepository.getDomains")
  };
}
function q(e) {
  if (e != null)
    return new Date(e);
}
function be(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: q(e.dato),
    fradato: q(e.fradato),
    tildato: q(e.tildato),
    saksnummer: e.saksnummer,
    beskrivelse: e.beskrivelse
  };
}
function K(e) {
  return {
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: e.dato?.getTime() ?? null,
    fradato: e.fradato?.getTime() ?? null,
    tildato: e.tildato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function Vn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...K(e)
  };
}
function he(e) {
  return Y(e, W);
}
function Ie(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await E(e, { where: t }, o)).map(be);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findByUid: async (t, o) => (await d(`planbehUid = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({ attributes: K(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("Planbehandling", p);
      return f[0];
    }, "PlanbehandlingRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...K(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Planbehandling", t.objectId);
      return i[0];
    }, "PlanbehandlingRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanbehandlingRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), he(t.fields);
    }, "PlanbehandlingRepository.getDomains")
  };
}
function ke(e) {
  if (e != null)
    return new Date(e);
}
function je(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    planbehUid: e.planbehUid,
    dispensasjonId: e.dispensasjonId,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype,
    dokumentstatus: e.dokumentstatus,
    arkivreferanse: e.arkivreferanse,
    arkivnavn: e.arkivnavn,
    dokumentdato: ke(e.dokumentdato),
    saksnummer: e.saksnummer,
    mimetype: e.mimetype,
    referansedokumentfil: e.referansedokumentfil,
    filnavn: e.filnavn,
    beskrivelse: e.beskrivelse
  };
}
function ve(e) {
  return {
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId ?? null,
    planbehUid: e.planbehUid ?? null,
    dispensasjonId: e.dispensasjonId ?? null,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype ?? null,
    dokumentstatus: e.dokumentstatus ?? null,
    arkivreferanse: e.arkivreferanse ?? null,
    arkivnavn: e.arkivnavn ?? null,
    dokumentdato: e.dokumentdato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    mimetype: e.mimetype ?? null,
    referansedokumentfil: e.referansedokumentfil ?? null,
    filnavn: e.filnavn ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
async function we(e, n, r) {
  const a = new FormData();
  a.append("attachment", r, r.name), a.append("f", "json");
  let l;
  try {
    l = await _(`${e}/${n}/addAttachment`, {
      method: "post",
      body: a,
      responseType: "json"
    });
  } catch (t) {
    throw new j(`Opplasting av vedlegg feilet: ${t?.message ?? t}`, t);
  }
  const d = l.data;
  if (d.error)
    throw new j(`Opplasting av vedlegg feilet: ${d.error.message}`);
  if (!d.addAttachmentResult?.success)
    throw new j("Opplasting av vedlegg feilet");
  return {
    path: `/${n}/attachments/${d.addAttachmentResult.objectId}`,
    filnavn: r.name,
    mimetype: r.type
  };
}
async function Ae(e, n) {
  try {
    const r = n.startsWith("/") ? `${e}${n}` : n, a = await _(r, { responseType: "blob" });
    return URL.createObjectURL(a.data);
  } catch {
    return null;
  }
}
function Fe(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await E(e, { where: t }, o)).map(je);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findForBehandling: (t, o) => d(`planbehUid = ${h(t)}`, o),
    findForDispensasjon: (t, o) => d(`dispensasjonId = ${h(t)}`, o),
    add: async (t, o) => l(async () => {
      const s = new g({ attributes: ve(t) }), p = (await a().applyEdits({ addFeatures: [s] })).addFeatureResults[0];
      if (p.error)
        throw new Error(p.error.message);
      const f = p.objectId;
      if (o) {
        const T = await we(e, f, o), X = new g({
          attributes: {
            OBJECTID: f,
            referansedokumentfil: T.path,
            filnavn: T.filnavn,
            mimetype: T.mimetype
          }
        });
        await a().applyEdits({ updateFeatures: [X] });
      }
      const S = await d(`OBJECTID = ${f}`);
      if (!S[0])
        throw new I("Plandokument", f);
      return S[0];
    }, "PlandokumentRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlandokumentRepository.delete"),
    fetchAttachmentBlobUrl: (t) => Ae(e, t)
  };
}
function Pe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle,
    organisasjon: e.organisasjon,
    kontaktperson: e.kontaktperson
  };
}
function O(e) {
  return {
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle ?? null,
    organisasjon: e.organisasjon ?? null,
    kontaktperson: e.kontaktperson ?? null
  };
}
function zn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...O(e)
  };
}
function Ee(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await E(e, { where: t }, o)).map(Pe);
  return {
    findForBehandling: (t, o) => d(`planbehUid = ${h(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: O(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("Aktor", p);
      return f[0];
    }, "AktorRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...O(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Aktor", t.objectId);
      return i[0];
    }, "AktorRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "AktorRepository.delete")
  };
}
function De(e) {
  if (e != null)
    return new Date(e);
}
function Be(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: De(e.vedtakEndeligPlanDato),
    begrunnelse: e.begrunnelse
  };
}
function Te(e) {
  return {
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    begrunnelse: e.begrunnelse ?? null
  };
}
function $e(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await E(e, { where: t }, o)).map(Be);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanIdFra = ${h(t)} OR nasjonalArealplanIdTil = ${h(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: Te(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("Planforhold", p);
      return f[0];
    }, "PlanforholdRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanforholdRepository.delete")
  };
}
function U(e) {
  if (e != null)
    return new Date(e);
}
function qe(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer,
    planidentifikasjon: e.planidentifikasjon,
    dispensasjonType: e.dispensasjonType,
    dispensasjonFra: e.dispensasjonFra,
    begrunnelse: e.begrunnelse,
    vedtaksdato: new Date(e.vedtaksdato),
    vertikalnivaa: e.vertikalnivaa,
    beskrivelse: e.beskrivelse,
    innvilgetDispensasjon: !!e.innvilgetDispensasjon,
    varigDispensasjon: !!e.varigDispensasjon,
    varighetFra: U(e.varighetFra),
    varighetTil: U(e.varighetTil),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    geometry: n
  };
}
function N(e) {
  return {
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer ?? null,
    planidentifikasjon: e.planidentifikasjon ?? null,
    dispensasjonType: e.dispensasjonType ?? null,
    dispensasjonFra: e.dispensasjonFra ?? null,
    begrunnelse: e.begrunnelse ?? null,
    vedtaksdato: e.vedtaksdato.getTime(),
    vertikalnivaa: e.vertikalnivaa ?? null,
    beskrivelse: e.beskrivelse ?? null,
    innvilgetDispensasjon: e.innvilgetDispensasjon ? 1 : 0,
    varigDispensasjon: e.varigDispensasjon ? 1 : 0,
    varighetFra: e.varighetFra?.getTime() ?? null,
    varighetTil: e.varighetTil?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null
  };
}
function Re(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => qe(i.attributes, i.geometry ? ne.fromJSON(i.geometry) : void 0)
  );
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findByDispensasjonId: async (t, o) => (await d(`dispensasjonId = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: N(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("Dispensasjon", p);
      return f[0];
    }, "DispensasjonRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...N(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Dispensasjon", t.objectId);
      return i[0];
    }, "DispensasjonRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "DispensasjonRepository.delete")
  };
}
function J(e) {
  if (e != null)
    return new Date(e);
}
function Ke(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn,
    avgjdato: J(e.avgjdato),
    gyldigtildato: J(e.gyldigtildato),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    informasjon: e.informasjon,
    geometry: n
  };
}
function M(e) {
  return {
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer ?? null,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn ?? null,
    avgjdato: e.avgjdato?.getTime() ?? null,
    gyldigtildato: e.gyldigtildato?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null,
    informasjon: e.informasjon ?? null
  };
}
function Oe(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Ke(i.attributes, i.geometry ? re.fromJSON(i.geometry) : void 0)
  );
  return {
    findForKommune: (t, o) => d(`kommunenummer = ${h(t)}`, o),
    findByForbudId: async (t, o) => (await d(`forbudId = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: M(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const p = i.objectId, f = await d(`OBJECTID = ${p}`);
      if (!f[0])
        throw new I("MidlertidigForbud", p);
      return f[0];
    }, "MidlertidigForbudRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...M(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("MidlertidigForbud", t.objectId);
      return i[0];
    }, "MidlertidigForbudRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "MidlertidigForbudRepository.delete")
  };
}
const _e = 0, Le = 1, Ce = 2, xe = 3, Se = 4, Ue = 5, Ne = 6;
function Hn(e) {
  const n = e.serviceUrl.replace(/\/$/, ""), r = (l) => `${n}/${l}`, { getToken: a } = e;
  return {
    arealplaner: ye(r(Ce), a),
    behandlinger: Ie(r(xe), a),
    dokumenter: Fe(r(Se), a),
    aktorer: Ee(r(Ue), a),
    planforhold: $e(r(Ne), a),
    dispensasjoner: Re(r(_e), a),
    midlertidigeForbud: Oe(r(Le), a)
  };
}
const c = {
  all: ["planregister"],
  arealplaner: {
    all: ["planregister", "arealplaner"],
    search: (e) => ["planregister", "arealplaner", "search", e],
    byNapId: (e) => ["planregister", "arealplaner", e],
    domains: ["planregister", "arealplaner", "domains"]
  },
  behandlinger: {
    all: ["planregister", "behandlinger"],
    forPlan: (e) => ["planregister", "behandlinger", e],
    byUid: (e) => ["planregister", "behandlinger", "uid", e],
    domains: ["planregister", "behandlinger", "domains"]
  },
  dokumenter: {
    all: ["planregister", "dokumenter"],
    forPlan: (e) => ["planregister", "dokumenter", "plan", e],
    forBehandling: (e) => ["planregister", "dokumenter", "behandling", e],
    forDispensasjon: (e) => ["planregister", "dokumenter", "dispensasjon", e]
  },
  aktorer: {
    all: ["planregister", "aktorer"],
    forBehandling: (e) => ["planregister", "aktorer", e]
  },
  planforhold: {
    all: ["planregister", "planforhold"],
    forPlan: (e) => ["planregister", "planforhold", e]
  },
  dispensasjoner: {
    all: ["planregister", "dispensasjoner"],
    forPlan: (e) => ["planregister", "dispensasjoner", e],
    byId: (e) => ["planregister", "dispensasjoner", "id", e]
  },
  midlertidigeForbud: {
    all: ["planregister", "midlertidigeForbud"],
    forKommune: (e) => ["planregister", "midlertidigeForbud", e],
    byId: (e) => ["planregister", "midlertidigeForbud", "id", e]
  }
}, Je = ["10", "11", "13", "20", "21", "34", "35", "30", "31"], Me = ["1", "2", "3", "4", "5", "6", "7", "8"], Qe = ["PBL2008", "PBL1985", "BL1965"], Ge = ["1", "2", "3", "4", "9"], B = (e) => ({ errorMap: () => ({ message: e }) }), Ve = u.object({
  plannavn: u.string().trim().min(1, "Plannavn er påkrevd").max(250, "Plannavn er for langt"),
  plantype: u.enum(Je, B("Velg en gyldig plantype")),
  planstatus: u.enum(Me, B("Velg en gyldig planstatus")).optional(),
  lovreferanse: u.enum(Qe, B("Velg en gyldig lovreferanse")),
  saksnummer: u.string().trim().min(1, "Saksnummer er påkrevd"),
  admomrkode: u.string().trim().min(1, "Kommunenummer er påkrevd").regex(/^\d{1,4}$/, "Kommunenummer må være inntil 4 siffer"),
  planId: u.string().trim().min(1, "PlanID er påkrevd"),
  saksaar: u.number().int().optional(),
  sakssekvensnr: u.number().int().optional(),
  forslagsstillerType: u.enum(Ge, B("Velg en gyldig forslagsstillertype")).optional(),
  ubehandletKlage: u.boolean().optional(),
  ubehandletInnsigelse: u.boolean().optional(),
  vedtaksdato: u.date().optional(),
  vedtakEndeligPlanDato: u.date().optional(),
  ikrafttredelsesdato: u.date().optional(),
  kunngjoringsdato: u.date().optional(),
  opprinneligAdmomrKode: u.string().trim().optional(),
  opprinneligPlanId: u.string().trim().optional(),
  planbestemmelser: u.boolean().optional()
}), ze = u.object({
  planbehUid: u.string().trim().min(1, "planbehUid er påkrevd"),
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  navn: u.string().trim().min(1, "Navn er påkrevd").max(250, "Navn er for langt"),
  planbehandlingtype: u.string().trim().min(1, "Velg behandlingstype"),
  dato: u.date({ required_error: "Dato er påkrevd", invalid_type_error: "Ugyldig dato" }),
  fradato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  tildato: u.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  saksnummer: u.string().trim().max(50, "Saksnummer er for langt").optional(),
  beskrivelse: u.string().trim().max(2e3, "Beskrivelsen er for lang").optional()
}).superRefine((e, n) => {
  e.fradato && e.tildato && e.tildato < e.fradato && n.addIssue({
    code: u.ZodIssueCode.custom,
    path: ["tildato"],
    message: "Til-dato kan ikke være før fra-dato"
  });
}), He = u.object({
  nasjonalArealplanId: u.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  tittel: u.string().trim().min(1, "Tittel er påkrevd").max(250, "Tittel er for lang"),
  dokumenttype: u.string().trim().optional()
});
async function We(e, n) {
  return e.arealplaner.findAll(n);
}
async function Ye(e, n, r) {
  return e.arealplaner.findByNapId(n, r);
}
async function Ze(e, n, r) {
  return e.arealplaner.search(n, r);
}
async function Xe(e, n, r) {
  const a = Ve.safeParse(n);
  if (!a.success) {
    const { message: i, path: p } = a.error.issues[0], f = p.join(".");
    throw new P(f ? `${f}: ${i}` : i, a.error);
  }
  const l = a.data, d = L(l.admomrkode), t = z(d, l.planId);
  if (await e.arealplaner.findByNapId(t, r))
    throw new P(
      `Plan-ID «${l.planId.trim()}» finnes allerede i kommune ${d} (${t}).`
    );
  const s = {
    ...l,
    admomrkode: d,
    planId: l.planId.trim(),
    nasjonalArealplanId: t,
    planstatus: l.planstatus ?? V,
    ubehandletKlage: l.ubehandletKlage ?? !1,
    ubehandletInnsigelse: l.ubehandletInnsigelse ?? !1,
    planbestemmelser: l.planbestemmelser ?? !1
  };
  return e.arealplaner.add(s);
}
async function en(e, n) {
  return e.arealplaner.getDomains(n);
}
async function nn(e, n) {
  return e.arealplaner.update(n);
}
async function rn(e, n) {
  return e.arealplaner.delete(n);
}
async function tn(e, n) {
  return e.behandlinger.getDomains(n);
}
async function an(e, n, r) {
  return e.behandlinger.findForPlan(n, r);
}
async function Wn(e, n, r) {
  return e.behandlinger.findByUid(n, r);
}
function Z(e) {
  const n = ze.safeParse(e);
  if (!n.success) {
    const { message: a, path: l } = n.error.issues[0], d = l.join(".");
    throw new P(d ? `${d}: ${a}` : a, n.error);
  }
  const r = n.data;
  return {
    ...r,
    saksnummer: r.saksnummer || void 0,
    beskrivelse: r.beskrivelse || void 0
  };
}
async function on(e, n) {
  return e.behandlinger.add(Z(n));
}
async function sn(e, n) {
  const { objectId: r, globalId: a, ...l } = n;
  return e.behandlinger.update({ objectId: r, globalId: a, ...Z(l) });
}
async function ln(e, n) {
  return e.behandlinger.delete(n);
}
function dn(e) {
  const n = He.safeParse(e);
  if (!n.success) {
    const { message: r, path: a } = n.error.issues[0], l = a.join(".");
    throw new P(l ? `${l}: ${r}` : r, n.error);
  }
  return e;
}
async function un(e, n, r) {
  return e.dokumenter.findForPlan(n, r);
}
async function cn(e, n, r) {
  return e.dokumenter.findForBehandling(n, r);
}
async function mn(e, n, r) {
  return e.dokumenter.findForDispensasjon(n, r);
}
async function pn(e, n, r) {
  return e.dokumenter.add(dn(n), r);
}
async function fn(e, n) {
  return e.dokumenter.fetchAttachmentBlobUrl(n);
}
async function gn(e, n) {
  return e.dokumenter.delete(n);
}
async function yn(e, n, r) {
  return e.aktorer.findForBehandling(n, r);
}
async function bn(e, n) {
  return e.aktorer.add(n);
}
async function hn(e, n) {
  return e.aktorer.update(n);
}
async function In(e, n) {
  return e.aktorer.delete(n);
}
async function kn(e, n, r) {
  return e.planforhold.findForPlan(n, r);
}
async function jn(e, n) {
  return e.planforhold.add(n);
}
async function vn(e, n) {
  return e.planforhold.delete(n);
}
async function wn(e, n, r) {
  return e.dispensasjoner.findForPlan(n, r);
}
async function Yn(e, n, r) {
  return e.dispensasjoner.findByDispensasjonId(n, r);
}
async function An(e, n) {
  return e.dispensasjoner.add(n);
}
async function Fn(e, n) {
  return e.dispensasjoner.update(n);
}
async function Pn(e, n) {
  return e.dispensasjoner.delete(n);
}
async function En(e, n, r) {
  return e.midlertidigeForbud.findForKommune(n, r);
}
async function Zn(e, n, r) {
  return e.midlertidigeForbud.findByForbudId(n, r);
}
async function Dn(e, n) {
  return e.midlertidigeForbud.add(n);
}
async function Bn(e, n) {
  return e.midlertidigeForbud.update(n);
}
async function Tn(e, n) {
  return e.midlertidigeForbud.delete(n);
}
const x = ae(null);
function Xn({ client: e, children: n }) {
  return /* @__PURE__ */ te(x.Provider, { value: e, children: n });
}
function m() {
  const e = Q(x);
  if (!e)
    throw new Error("usePlanregisterClient must be used inside <PlanregisterClientProvider>");
  return e;
}
function er() {
  return Q(x);
}
function nr() {
  const e = m();
  return k({
    queryKey: c.arealplaner.all,
    queryFn: ({ signal: n }) => We(e, { signal: n })
  });
}
function rr(e) {
  const n = m();
  return k({
    queryKey: c.arealplaner.search(e),
    queryFn: ({ signal: r }) => Ze(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function tr(e) {
  const n = m();
  return k({
    queryKey: c.arealplaner.byNapId(e ?? ""),
    queryFn: ({ signal: r }) => Ye(n, e, { signal: r }),
    enabled: !!e
  });
}
function ar() {
  const e = m();
  return k({
    queryKey: c.arealplaner.domains,
    queryFn: ({ signal: n }) => en(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function or() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => Xe(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function sr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => nn(e, r),
    onSuccess: (r) => {
      n.invalidateQueries({ queryKey: c.arealplaner.all }), n.invalidateQueries({ queryKey: c.arealplaner.byNapId(r.nasjonalArealplanId) });
    }
  });
}
function lr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => rn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.arealplaner.all })
  });
}
function ir() {
  const e = m();
  return k({
    queryKey: c.behandlinger.domains,
    queryFn: ({ signal: n }) => tn(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function dr(e) {
  const n = m();
  return k({
    queryKey: c.behandlinger.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => an(n, e, { signal: r }),
    enabled: !!e
  });
}
function ur() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => on(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function cr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => sn(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: c.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function mr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => ln(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.behandlinger.forPlan(e) })
  });
}
function pr(e) {
  const n = m();
  return k({
    queryKey: c.dokumenter.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => un(n, e, { signal: r }),
    enabled: !!e
  });
}
function fr(e) {
  const n = m();
  return k({
    queryKey: c.dokumenter.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => cn(n, e, { signal: r }),
    enabled: !!e
  });
}
function gr(e) {
  const n = m();
  return k({
    queryKey: c.dokumenter.forDispensasjon(e ?? ""),
    queryFn: ({ signal: r }) => mn(n, e, { signal: r }),
    enabled: !!e
  });
}
function yr() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => pn(e, r.input, r.file),
    onSuccess: (r) => {
      r.nasjonalArealplanId && n.invalidateQueries({ queryKey: c.dokumenter.forPlan(r.nasjonalArealplanId) }), r.planbehUid && n.invalidateQueries({ queryKey: c.dokumenter.forBehandling(r.planbehUid) });
    }
  });
}
function br() {
  const e = m(), n = y();
  return b({
    mutationFn: (r) => gn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: c.dokumenter.all })
  });
}
function hr() {
  const e = m();
  return (n) => fn(e, n);
}
function Ir(e) {
  const n = m();
  return k({
    queryKey: c.aktorer.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => yn(n, e, { signal: r }),
    enabled: !!e
  });
}
function kr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => bn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function jr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => hn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function vr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => In(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.aktorer.forBehandling(e) })
  });
}
function wr(e) {
  const n = m();
  return k({
    queryKey: c.planforhold.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => kn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Ar(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => jn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Fr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => vn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.planforhold.forPlan(e) })
  });
}
function Pr(e) {
  const n = m();
  return k({
    queryKey: c.dispensasjoner.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => wn(n, e, { signal: r }),
    enabled: !!e
  });
}
function Er(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => An(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Dr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Fn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Br(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Pn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.dispensasjoner.forPlan(e) })
  });
}
function Tr(e) {
  const n = m();
  return k({
    queryKey: c.midlertidigeForbud.forKommune(e ?? ""),
    queryFn: ({ signal: r }) => En(n, e, { signal: r }),
    enabled: !!e
  });
}
function $r(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Dn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function qr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Bn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
function Rr(e) {
  const n = m(), r = y();
  return b({
    mutationFn: (a) => Tn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: c.midlertidigeForbud.forKommune(e) })
  });
}
const $n = {
  plantype: [
    { code: "10", label: "Fylkesplan" },
    { code: "11", label: "Fylkesdelplan" },
    { code: "13", label: "Regional plan" },
    { code: "20", label: "Kommuneplan" },
    { code: "21", label: "Kommunedelplan" },
    { code: "34", label: "Områderegulering" },
    { code: "35", label: "Detaljregulering" },
    { code: "30", label: "Reguleringsplan (pbl 1985)" },
    { code: "31", label: "Bebyggelsesplan (pbl 1985)" }
  ],
  planstatus: [
    { code: "1", label: "Planlegging igangsatt" },
    { code: "2", label: "Planforslag" },
    { code: "3", label: "Endelig vedtatt" },
    { code: "4", label: "Opphevet" },
    { code: "5", label: "Utgått/erstattet" },
    { code: "6", label: "Vedtatt med utsatt rettsvirkning" },
    { code: "7", label: "Endelig vedtatt med tidsbegrensning" },
    { code: "8", label: "Overstyrt" }
  ],
  lovreferanse: [
    { code: "PBL2008", label: "Plan- og bygningsloven 2008" },
    { code: "PBL1985", label: "Plan- og bygningsloven 1985" },
    { code: "BL1965", label: "Bygningsloven 1965" }
  ],
  forslagsstillerType: [
    { code: "1", label: "Kommunen" },
    { code: "2", label: "Statlig myndighet" },
    { code: "3", label: "Fylkeskommune" },
    { code: "4", label: "Privat forslagsstiller" },
    { code: "9", label: "Annen" }
  ]
}, qn = {
  planbehandlingtype: [
    { code: "A", label: "Testbehandling A" },
    { code: "B", label: "Testbehandling B" },
    { code: "C", label: "Testbehandling C" }
  ]
};
let Rn = 1;
const v = () => Rn++, A = () => `{${v().toString().padStart(8, "0")}-0000-0000-0000-000000000000}`;
class Kr {
  constructor() {
    this.store = [];
  }
  findAll(n) {
    return Promise.resolve([...this.store]);
  }
  findByNapId(n, r) {
    return Promise.resolve(this.store.find((a) => a.nasjonalArealplanId === n) ?? null);
  }
  search(n, r) {
    const a = n.toLowerCase();
    return Promise.resolve(this.store.filter(
      (l) => l.plannavn?.toLowerCase().includes(a) || l.planId.includes(n) || l.nasjonalArealplanId.includes(n)
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Arealplan ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve($n);
  }
}
class Or {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByUid(n, r) {
    return Promise.resolve(this.store.find((a) => a.planbehUid === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planbehandling ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(qn);
  }
}
class _r {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  findForDispensasjon(n, r) {
    return Promise.resolve(this.store.filter((a) => a.dispensasjonId === n));
  }
  add(n, r) {
    const a = {
      ...n,
      objectId: v(),
      globalId: A(),
      ...r ? { filnavn: r.name, mimetype: r.type, referansedokumentfil: `fake://${r.name}` } : {}
    };
    return this.store.push(a), Promise.resolve(a);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  fetchAttachmentBlobUrl(n) {
    return Promise.resolve(`fake-blob://${n}`);
  }
}
class Lr {
  constructor() {
    this.store = [];
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Aktor ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Cr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter(
      (a) => a.nasjonalArealplanIdFra === n || a.nasjonalArealplanIdTil === n
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class xr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByDispensasjonId(n, r) {
    return Promise.resolve(this.store.find((a) => a.dispensasjonId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Dispensasjon ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Sr {
  constructor() {
    this.store = [];
  }
  findForKommune(n, r) {
    return Promise.resolve(this.store.filter((a) => a.kommunenummer === n));
  }
  findByForbudId(n, r) {
    return Promise.resolve(this.store.find((a) => a.forbudId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: A() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`MidlertidigForbud ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
export {
  G as AbortedError,
  oe as AuthError,
  H as CODELIST_FIELDS,
  V as DEFAULT_PLANSTATUS,
  $n as FAKE_AREALPLAN_DOMAINS,
  qn as FAKE_PLANBEHANDLING_DOMAINS,
  Ge as FORSLAGSSTILLER_VALUES,
  Lr as FakeAktorRepository,
  Kr as FakeArealplanRepository,
  xr as FakeDispensasjonRepository,
  Sr as FakeMidlertidigForbudRepository,
  Or as FakePlanbehandlingRepository,
  _r as FakePlandokumentRepository,
  Cr as FakePlanforholdRepository,
  Qe as LOVREFERANSE_VALUES,
  j as NetworkError,
  I as NotFoundError,
  W as PLANBEHANDLING_CODELIST_FIELDS,
  Me as PLANSTATUS_VALUES,
  Je as PLANTYPE_VALUES,
  Xn as PlanregisterClientProvider,
  F as PlanregisterError,
  P as ValidationError,
  Pe as aktorFromAttrs,
  O as aktorInputToAttrs,
  zn as aktorToAttrs,
  ie as arealplanFromAttrs,
  Ve as arealplanInputSchema,
  R as arealplanInputToAttrs,
  Qn as arealplanToAttrs,
  ue as buildArealplanDomains,
  Y as buildDomains,
  Gn as buildInClause,
  he as buildPlanbehandlingDomains,
  bn as createAktor,
  Ee as createArcgisAktorRepository,
  ye as createArcgisArealplanRepository,
  Re as createArcgisDispensasjonRepository,
  Oe as createArcgisMidlertidigForbudRepository,
  Ie as createArcgisPlanbehandlingRepository,
  Fe as createArcgisPlandokumentRepository,
  $e as createArcgisPlanforholdRepository,
  Xe as createArealplan,
  An as createDispensasjon,
  Dn as createMidlertidigForbud,
  on as createPlanbehandling,
  pn as createPlandokument,
  jn as createPlanforhold,
  Hn as createPlanregisterClient,
  In as deleteAktor,
  rn as deleteArealplan,
  Pn as deleteDispensasjon,
  Tn as deleteMidlertidigForbud,
  ln as deletePlanbehandling,
  gn as deletePlandokument,
  vn as deletePlanforhold,
  z as deriveNasjonalArealplanId,
  qe as dispensasjonFromAttrs,
  N as dispensasjonInputToAttrs,
  Mn as domain,
  se as domainLabel,
  le as domainOptions,
  ce as escapeSqlValue,
  fn as fetchPlandokumentAttachmentBlobUrl,
  We as findAllArealplaner,
  Ye as findArealplanByNapId,
  Wn as findBehandlingByUid,
  Yn as findDispensasjonById,
  Zn as findMidlertidigForbudById,
  yn as loadAktorerForBehandling,
  en as loadArealplanDomains,
  an as loadBehandlingerForPlan,
  wn as loadDispensasjonerForPlan,
  cn as loadDokumenterForBehandling,
  mn as loadDokumenterForDispensasjon,
  un as loadDokumenterForPlan,
  En as loadMidlertidigForbudForKommune,
  tn as loadPlanbehandlingDomains,
  kn as loadPlanforholdForPlan,
  Ke as midlertidigForbudFromAttrs,
  M as midlertidigForbudInputToAttrs,
  L as normalizeAdmomrkode,
  be as planbehandlingFromAttrs,
  ze as planbehandlingInputSchema,
  K as planbehandlingInputToAttrs,
  Vn as planbehandlingToAttrs,
  je as plandokumentFromAttrs,
  He as plandokumentInputSchema,
  ve as plandokumentInputToAttrs,
  Be as planforholdFromAttrs,
  Te as planforholdInputToAttrs,
  c as planregisterKeys,
  C as queryFeaturesPaged,
  E as queryTablePaged,
  h as qv,
  Ze as searchArealplaner,
  hn as updateAktor,
  nn as updateArealplan,
  Fn as updateDispensasjon,
  Bn as updateMidlertidigForbud,
  sn as updatePlanbehandling,
  Ir as useAktorer,
  tr as useArealplan,
  ar as useArealplanDomains,
  nr as useArealplaner,
  rr as useArealplanerSearch,
  kr as useCreateAktor,
  or as useCreateArealplan,
  Er as useCreateDispensasjon,
  $r as useCreateMidlertidigForbud,
  ur as useCreatePlanbehandling,
  yr as useCreatePlandokument,
  Ar as useCreatePlanforhold,
  vr as useDeleteAktor,
  lr as useDeleteArealplan,
  Br as useDeleteDispensasjon,
  Rr as useDeleteMidlertidigForbud,
  mr as useDeletePlanbehandling,
  br as useDeletePlandokument,
  Fr as useDeletePlanforhold,
  Pr as useDispensasjoner,
  hr as useFetchPlandokumentAttachmentUrl,
  Tr as useMidlertidigeForbud,
  ir as usePlanbehandlingDomains,
  dr as usePlanbehandlinger,
  fr as usePlandokumenterForBehandling,
  gr as usePlandokumenterForDispensasjon,
  pr as usePlandokumenterForPlan,
  wr as usePlanforhold,
  m as usePlanregisterClient,
  er as usePlanregisterClientOptional,
  jr as useUpdateAktor,
  sr as useUpdateArealplan,
  Dr as useUpdateDispensasjon,
  qr as useUpdateMidlertidigForbud,
  cr as useUpdatePlanbehandling
};
//# sourceMappingURL=index.mjs.map
